@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .root {
    display: flex;
    width: 100%;
    background-color: var(--background-soft);
    border: 1px solid var(--border-soft);
    @include border-radius-r1;
    padding: 4px;
    gap: 4px;
  }

  .item {
    @include typography-v2-body-sm;
    background: none;
    border: none;
    width: 100%;
    color: var(--text-default);
    @include border-radius-r1;
    padding: 6px 8px;
    cursor: pointer;
    text-transform: capitalize;

    &:hover {
      background-color: var(--surface-hover);
    }

    &:focus-visible {
      outline: 2px solid var(--border-focus);
    }
  }

  .itemActive {
    color: var(--text-primary);
    background-color: var(--custom-active-bg, var(--action-primary-soft-hover));

    &:hover {
      background-color: var(--action-primary-soft-hover);
    }
  }

  .itemDisabled {
    color: var(--text-disabled);
    cursor: not-allowed;

    &:hover {
      background-color: transparent;
    }
  }
}
